function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "none",
  stroke: "#8489B0",
  strokeWidth: 5.5,
  strokeMiterlimit: 10,
  cx: 82.75,
  cy: 82.75,
  r: 80
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#8489B0",
  strokeWidth: 5.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 109.6,
  y1: 121.018,
  x2: 55.9,
  y2: 121.018
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  fill: "none",
  stroke: "#8489B0",
  strokeWidth: 5.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  x1: 55.9,
  y1: 44.482,
  x2: 109.6,
  y2: 44.482
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8489B0",
  strokeWidth: 5.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: " M62.444,44.482V62.54c0,11.162,20.21,20.21,20.21,20.21s20.21-9.048,20.21-20.21V44.482"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#8489B0",
  strokeWidth: 5.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  d: " M103.056,121.018V102.96c0-11.161-20.21-20.211-20.21-20.211s-20.21,9.05-20.21,20.211v18.058"
});

var SvgInCorso = function SvgInCorso(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 167,
    height: 166,
    viewBox: "-0.948 -0.467 167 166",
    enableBackground: "new -0.948 -0.467 167 166",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInCorso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/in_corso.ed6093ba.svg";
export { ForwardRef as ReactComponent };